export default __webpack_public_path__ + "static/media/learose4-480w.32539b2b.png";